<template>
    <div class="h-full border-r overflow-y-scroll">

        <sub-menu
            :links="links"
            header="Family Law"
        ></sub-menu>

    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubMenu from '@/components/menu/SubMenu.vue'
import menus from '@/utils/menus'

export default defineComponent({
    name: 'FamilySidebar',
    components: {
        SubMenu
    },
    setup() {
        const { familySidebarLinks } = menus();

        return {
            links: familySidebarLinks,
        }
    }  
})
</script>